module.exports = __webpack_public_path__ + "static/media/loading-spinner-pulse-2x.a88cd1d0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/ui/common/rebranding/assets/loading-spinner-pulse-2x.gif
// module id = 1432
// module chunks = 146